import { validatePlaceholders } from 'components/Dashboard/Influence/CrmEmails/CrmEmailComponent/emailSignatureFunctions';

// Old email campaigns stored legacy mail-merge chips (e.g. "salutation_text") directly in the
// interaction's body/description - normalize them to today's "@salutation" pill before loading
// into an editor. Shared by every /api/crm-interaction/:id consumer (CrmInteractionDetail's
// full-page editor, LogInteractionModal's edit flow) so a fix here covers both at once.
//
// preserveUnrecognizedFields: true - this call site has no team mailMergeFields list, so any
// custom-field pill (e.g. "@nick-name") is "unrecognized" as far as validatePlaceholders can tell;
// without this it would get flattened into uppercase text alongside the actual legacy chips.
const normalizeInteractionHtmlBody = (result) => {
  const html = result?.htmlBody ?? result?.description ?? '';
  return html ? validatePlaceholders({ emailBody: html, preserveUnrecognizedFields: true }) : html;
};

export default normalizeInteractionHtmlBody;
